export const APP_NAME = 'uniports';

export const SITE_NAME = 'Uniports';

export const SECRET_KEY = 'b00b02c654a6f6833c1399119dba85da20e49e0c3db1dce652c7f64ebcc4647a';

export const API_VERSION = 'v1';

export const API_STANDARDS_TREE = 'vnd';

export const API_HOST = process.env.API_HOST;

export const TOKEN_EXPIRE_NOTICE_KEY = 'token_expire_at_minutes';

export const BLACKEND_URL = process.env.BLACKEND_URL;

export const GOOGLE_MAP_KEY = 'AIzaSyA0qQKbPOvp82gmd-QS5OiLaDQkr4fz4IQ';

export const COMPANY_ADDRESS = '葵涌葵榮路29-37號成美工業大廈';

export const COMPANY_COORDINATE_LAT = 22.367031;

export const COMPANY_COORDINATE_LNG = 114.133882;

export const TEL = '852 - 39568268';

export const FACE_BOOK = 'www.facebook.com/uniports.hk';



// WEBPACK FOOTER //
// ./src/constants.js